import apiClient from "../services/ApiClient";
import { useEffect, useState } from "react";
import { components } from "../types/OnuoGate";
import {
  Button,
  DatePicker,
  FloatButton,
  Form,
  GetProp,
  InputNumber,
  Modal,
  Space,
  Table,
  TableColumnsType,
  TableProps,
  Tag,
} from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import EditModal from "../components/EditModal";
import { TableRowSelection } from "antd/es/table/interface";
import { EditFilled } from "@ant-design/icons";
import SelectLogoDevice from "../components/SelectLogoDevice";
import {
  PageContainer,
  ProColumns,
  ProTable,
} from "@ant-design/pro-components";

const { RangePicker } = DatePicker;

interface TableParams {
  pagination?: TablePaginationConfig;
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}

type ColumnsType<T extends object = object> = TableProps<T>["columns"];
type TablePaginationConfig = Exclude<
  GetProp<TableProps, "pagination">,
  boolean
>;

export default function LogoDefaultConfig(_props: any) {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { state } = useLocation();


  const columns: ProColumns<components["schemas"]["LogoDefaultConfig"]>[] = [

    {
      title: "BayiKodu",
      dataIndex: 'dealerCode'
    },
    {
      title: "AltBayiKodu",
      dataIndex: 'subDealerCode'
    },
    {
      title: "Satışcı",
      dataIndex: 'logoUserName'
    },
    {
      title: "Hedef Adres",
      dataIndex: 'shipmentAddressClientCode'
    },
    {
      title: "Teslimat Tipi",
      dataIndex: 'deliveryType',
      render: (i, row) => {
        return row.deliveryType == 100 ? "Kargo" : "Depo";
      }
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      search: false,
      render: (_: any, record: components["schemas"]["LogoDefaultConfig"]) => (
        <Space size="middle">
          <Link to={"/orders/modal/" + record.id} state={{ from: "home" }}>
            <Button color={"primary"} variant={"solid"}>
              Görüntüle
            </Button>
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <PageContainer title="Ön tanımlı Logo Ayarları">
      
    
      <ProTable<components["schemas"]["LogoDefaultConfig"]>
        //onChange={handleTableChange}

          pagination={false}
        form={{
          layout: "vertical",
          params: {
            test: 1,
          },
          syncToUrl: (values, type) => {
            if (type === "get") {
              if (values.openOrderLine) {
                return {
                  ...values,
                  openOrderLine: JSON.parse(values.openOrderLine),
                };
              }
            }
            return values;
          },
        }}
        request={async (params, sort, filter) => {
          const { current, pageSize, ...otherFields } = params;

          const response = await apiClient.getConfigs();

          return {
            data: response.data || [],
            success: true,
            total: response.data.length,
          };
        }}
        rowKey={(x) => x.id?.toString() || "0"}
        columns={columns}
      />
    </PageContainer>
  );
}
